// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"HX6FVzEbhMtkXOi9gEvA0"};